/**
 * IvCert
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { Observable } from 'rxjs';
import { IvCertGenericResponseCertificateClientResponse } from '../model/ivCertGenericResponseCertificateClientResponse';
import { IvGenericRestResponseCertificateClientResponse } from '../model/ivGenericRestResponseCertificateClientResponse';
import { BASE_PATH } from '../variables';
import { Configuration } from '../configuration';
import { DateParser } from "../date";
import { PersonalizationsService } from '../../base/services/personalizations/personalizations.service';
import { Environment } from '../../models/environment';
import { EnvironmentService } from './environment.service';

@Injectable()
export class CertService {

    environment: Environment;
    protected basePath: string;
    protected apiVersion: string;
    public defaultHeaders = new HttpHeaders().set('timeClient', DateParser.parse(new Date()));
    public configuration = new Configuration();


    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration, private _personalization: PersonalizationsService, private _env: EnvironmentService) {
        this.environment = this._personalization.sendEnv;
        this.apiVersion = this._env.apiVersion;
        this.basePath = this.environment?.url_api;
        this.defaultHeaders = this.defaultHeaders.set('X-Request-ID', 'app-front');
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * Get certificate selected by user
     *
     * @param callbackId
     * @param Authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public certGetCertificateClient(callbackId: string, Authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseCertificateClientResponse>;
    public certGetCertificateClient(callbackId: string, Authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseCertificateClientResponse>>;
    public certGetCertificateClient(callbackId: string, Authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseCertificateClientResponse>>;
    public certGetCertificateClient(callbackId: string, Authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (callbackId === null || callbackId === undefined) {
            throw new Error('Required parameter callbackId was null or undefined when calling certGetCertificateClient.');
        }

        if (Authorization === null || Authorization === undefined) {
            throw new Error('Required parameter Authorization was null or undefined when calling certGetCertificateClient.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (callbackId !== undefined && callbackId !== null) {
            queryParameters = queryParameters.set('callbackId', <any>callbackId);
        }

        let headers = this.defaultHeaders;
        if (Authorization !== undefined && Authorization !== null) {
            headers = headers.set('Authorization', String(Authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<IvCertGenericResponseCertificateClientResponse>(`${this.basePath}/api/${this.apiVersion}/Cert/CertificateClient`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get qualified certificate selected by user
     *
     * @param idOperation
     * @param callbackId
     * @param Authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public certGetCertificateClientQERDS(idOperation: string, callbackId: string, Authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvGenericRestResponseCertificateClientResponse>;
    public certGetCertificateClientQERDS(idOperation: string, callbackId: string, Authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvGenericRestResponseCertificateClientResponse>>;
    public certGetCertificateClientQERDS(idOperation: string, callbackId: string, Authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvGenericRestResponseCertificateClientResponse>>;
    public certGetCertificateClientQERDS(idOperation: string, callbackId: string, Authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idOperation === null || idOperation === undefined) {
            throw new Error('Required parameter idOperation was null or undefined when calling certGetCertificateClientQERDS.');
        }

        if (callbackId === null || callbackId === undefined) {
            throw new Error('Required parameter callbackId was null or undefined when calling certGetCertificateClientQERDS.');
        }

        if (Authorization === null || Authorization === undefined) {
            throw new Error('Required parameter Authorization was null or undefined when calling certGetCertificateClientQERDS.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }
        if (callbackId !== undefined && callbackId !== null) {
            queryParameters = queryParameters.set('callbackId', <any>callbackId);
        }

        let headers = this.defaultHeaders;
        if (Authorization !== undefined && Authorization !== null) {
            headers = headers.set('Authorization', String(Authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<IvGenericRestResponseCertificateClientResponse>(`${this.basePath}/api/${this.apiVersion}/Cert/CertificateClientQERDS`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
